export default "__VITE_ASSET__2761dce5__"